import React from 'react';
import { Box, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// Icones MUI usados pelos paths dos tours. Adicione novos aqui conforme
// surgirem novos passos no STEP_CATALOG.
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PanToolOutlinedIcon from '@mui/icons-material/PanToolOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import SupervisedUserCircleOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import GroupWorkOutlinedIcon from '@mui/icons-material/GroupWorkOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import StyleOutlinedIcon from '@mui/icons-material/StyleOutlined';
import MouseOutlinedIcon from '@mui/icons-material/MouseOutlined';
import HighlightAltOutlinedIcon from '@mui/icons-material/HighlightAltOutlined';

const ICON_BY_NAME = {
    ticket: ConfirmationNumberOutlinedIcon,
    list: ListAltOutlinedIcon,
    plus: AddCircleOutlineIcon,
    edit: EditOutlinedIcon,
    hand: PanToolOutlinedIcon,
    close: CheckCircleOutlineIcon,
    user: PersonAddOutlinedIcon,
    users: SupervisedUserCircleOutlinedIcon,
    organization: BusinessOutlinedIcon,
    category: CategoryOutlinedIcon,
    config: TuneOutlinedIcon,
    team: GroupOutlinedIcon,
    teamWork: GroupWorkOutlinedIcon,
    automation: BoltOutlinedIcon,
    template: StyleOutlinedIcon,
    click: MouseOutlinedIcon,
    select: HighlightAltOutlinedIcon,
};

// Paleta — alinhada com o restante do onboarding.
const COLORS = {
    primary: '#8BC34A',
    primaryDark: '#7cb342',
    primaryBg: '#f1f8e9',
    chipBg: '#f5f7fa',
    chipBorder: '#e6e8eb',
    chipText: '#5f6368',
    chevron: '#bdc1c6',
};

const renderIcon = (iconName, color) => {
    const Cmp = ICON_BY_NAME[iconName];
    if (!Cmp) return null;
    return <Cmp sx={{ fontSize: 14, color, mr: 0.5 }} />;
};

/**
 * Breadcrumb visual do caminho de menu pra chegar na tela do tour.
 * Renderizado dentro do balao de step de intro pra orientar o usuario.
 *
 * Props:
 *   path: [{ iconName: 'ticket', labelKey: 'menu.calleds' }, ...]
 *   intl: react-intl injectIntl prop
 */
const TourMenuPath = ({ path, intl }) => {
    if (!Array.isArray(path) || path.length === 0) return null;

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '4px 6px',
                mb: 1.5,
                pb: 1.5,
                borderBottom: '1px dashed #eef0f2',
            }}
        >
            {path.map((node, idx) => {
                const isLast = idx === path.length - 1;
                const label = node.labelKey
                    ? intl.formatMessage({ id: node.labelKey })
                    : (node.label || '');
                const bg = isLast ? COLORS.primaryBg : COLORS.chipBg;
                const text = isLast ? COLORS.primaryDark : COLORS.chipText;
                const border = isLast ? COLORS.primary : COLORS.chipBorder;

                return (
                    <React.Fragment key={`tour-menu-path-${idx}`}>
                        <Box
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                px: 0.85,
                                py: 0.3,
                                borderRadius: '6px',
                                backgroundColor: bg,
                                border: `1px solid ${border}`,
                                lineHeight: 1.2,
                            }}
                        >
                            {renderIcon(node.iconName, text)}
                            <Typography
                                component="span"
                                sx={{
                                    fontSize: 11.5,
                                    fontWeight: isLast ? 700 : 600,
                                    color: text,
                                    letterSpacing: 0.1,
                                }}
                            >
                                {label}
                            </Typography>
                        </Box>
                        {!isLast && (
                            <ChevronRightIcon
                                sx={{ fontSize: 14, color: COLORS.chevron }}
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </Box>
    );
};

export default TourMenuPath;
